// (function () {
//   'use strict';

// polyfills
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

// function isValidEmail(email) {
//   return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(email);
// }

document.addEventListener('DOMContentLoaded', function () {

  // ----- START - RESERVDELSBESTÄLLNING -------- //
  // var sparePartsForm = document.getElementById( 'service-form-reservdelsbestallning' );
  // let sparePartsFormProcessing = false;

  // if (sparePartsForm) {
  //   var tymsg = sparePartsForm.querySelector('#thank-you-message-wrapper');
  //   var errmsg = sparePartsForm.querySelector('#error-message-wrapper');
  //   // var tymsgContainer = formNewsletter.getElementById('ty-msg-container');
  //   var errMsgContainer = document.querySelector('#err-msg-container');

  //   const btnSend = sparePartsForm.querySelector('.btn-send'),
  //         btnSendValue = sparePartsForm.querySelector('.btn-send').textContent,
  //         loading = sparePartsForm.dataset.loading;


  //   var errorMessages = {
  //     genericError: decodeURIComponent(errMsgContainer.dataset.genericError),
  //     fieldError: decodeURIComponent(errMsgContainer.dataset.fieldError),
  //   };

  //   sparePartsForm.addEventListener('keypress', function (event) {
  //     var code = event.keyCode || event.which;
  //     if (code === 13) {
  //       event.preventDefault();
  //       return false;
  //     }
  //   });

  //   sparePartsForm.addEventListener( 'submit', function (event) {
  //       event.preventDefault();

  //       // noop if form has already been sent and is successful
  //       if (sparePartsFormProcessing) return false;

  //       sparePartsFormProcessing = true;
  //       tymsg.style.display = 'none';
  //       errmsg.style.display = 'none';

  //       // initialize button
  //       btnSend.disabled = true;
  //       btnSend.textContent = loading;
  //       errmsg.style.display = 'none';

  //       // initialize error flags and messages
  //       let hasErrors = false;
  //       errmsg.querySelector('.message').innerHTML = errorMessages.genericError;

  //       // validate email
  //       let emailInput = sparePartsForm.querySelector('#email');
  //       if (isValidEmail(emailInput.value))
  //         emailInput.classList.remove('error');
  //       else {
  //         emailInput.classList.add('error');
  //         hasErrors = true;
  //       }

  //       if (hasErrors) {
  //         // show field error
  //         showError(tymsg, errmsg, errorMessages.fieldError, event, btnSend, btnSendValue);

  //         sparePartsFormProcessing = false;
  //         return false;
  //       }

  //       // form submission
  //       var action = 'form_spareparts';
  //       var url = sparePartsForm.dataset.url;
  //       let data = new FormData(sparePartsForm);
  //       data.append('action', action);

  //       fetch(url, { method: 'POST', body: data })
  //         .then(function (response) {
  //           if (!response.ok) {
  //             throw Error(response.statusText);
  //           }

  //           return response.json();
  //         })
  //         .then(function () {
  //           sparePartsFormProcessing = false;
  //           tymsg.style.display = 'block';
  //           errmsg.style.display = 'none';
  //           event.target.scrollIntoView({ behavior: 'smooth' });

  //           btnSend.disabled = true;
  //           btnSend.textContent = btnSendValue;
  //         })
  //         .catch(function (e) {
  //           sparePartsFormProcessing = false;
  //           console.error(e);

  //           // show generic error
  //           showError(tymsg, errmsg, errorMessages.genericError, event, btnSend, btnSendValue);
  //         });
  //     },
  //     false
  //   );
  // }
  // ----- END - RESERVDELSBESTÄLLNING -------- //

  // ----- START - SERVICE FORM FILES -------- //

  if (document.getElementById('service-form-serviceinstruktioner')) {
    document
      .querySelectorAll('.service-form-files')
      .forEach(function (formFile) {
        var isFormFileProcessing = false;
        var errmsg = formFile.querySelector('#error-message-wrapper');
        var errMsgContainer = document.querySelector('#err-msg-container');

        // initialize button
        const btnSend = formFile.querySelector('.btn-send'),
          btnSendValue = formFile.querySelector('.btn-send').textContent,
          loading = formFile.querySelector('.service-form').dataset.loading,
          form = formFile.querySelector('.service-form');

        var errorMessages = {
          genericError: decodeURIComponent( errMsgContainer.dataset.genericError ),
          fieldError: decodeURIComponent(errMsgContainer.dataset.fieldError),
        };

        formFile.addEventListener('keypress', function (event) {
          var code = event.keyCode || event.which;
          if (code === 13) {
            event.preventDefault();
            return false;
          }
        });

        formFile.addEventListener(
          'submit',
          function (event) {
            event.preventDefault();

            // noop if form has already been sent and is successful
            if (isFormFileProcessing) return false;

            // initialize buttons
            isFormFileProcessing = true;
            btnSend.disabled = true;
            btnSend.textContent = loading;
            errmsg.style.display = 'none';

            // initialize error flags and messages
            let hasErrors = false;
            errmsg.querySelector('.message').innerHTML = errorMessages.genericError;

            if (hasErrors) {
              showError(null, errmsg, errorMessages.fieldError, event, btnSend, btnSendValue);

              isFormFileProcessing = false;
              return false;
            }

            // form submission
            var action = 'form_file';
            var url = form.dataset.url;
            let data = new FormData(form);
            data.append('action', action);

            fetch(url, { method: 'POST', body: data })
              .then(function (response) {
                if (!response.ok) {
                  var acceptableStatusCodes = [200, 401];
                  if (!acceptableStatusCodes.includes(response.status)) {
                    throw Error(response.statusText);
                  }
                }
                return Promise.all([response.status, response.text()]);
              })
              .then(function (response) {
                var status = response[0];
                var messageTxt = response[1];

                if (status == 401) {
                  showError(null, errmsg, errorMessages.fieldError, event, btnSend, btnSendValue);

                } else {
                  formFile.querySelector( '.service-content-inner' ).innerHTML = messageTxt;

                  const contentFormH = document.querySelector( '.drop-wrapper.is-active .drop-content-inner' ).offsetHeight;
                  document.querySelector( '.drop-wrapper.is-active .drop-content' ).style.maxHeight = contentFormH + 'px';
                  localStorage.setItem('setFormFileLoad_' + form.id, 'set');
                }

                isFormFileProcessing = false;
              })
              .catch(function (e) {
                isFormFileProcessing = false;
                console.log(e);

                // show generic error
                showError(null, errmsg, errorMessages.genericError, event, btnSend, btnSendValue);
              });
          },
          false
        );
      });
  }

  // ----- END - SERVICE FORM FILES -------- //



  // ----- START - SERVICE REKLAMATION -------- //
  // const reklamationForm = document.getElementById('service-form-reklamation');
  // let isReklamationFormProcessing = false;

  // if( reklamationForm ) {
  //   const tymsg = reklamationForm.querySelector('#thank-you-message-wrapper');
  //   const errmsg = reklamationForm.querySelector('#error-message-wrapper');
  //   // var tymsgContainer = formNewsletter.getElementById('ty-msg-container');
  //   const errMsgContainer = document.querySelector('#err-msg-container');

  //   const btnSend = reklamationForm.querySelector('.btn-send'),
  //         btnSendValue = reklamationForm.querySelector('.btn-send').textContent,
  //         loading = reklamationForm.dataset.loading;

  //   const errorMessages = {
  //     genericError: decodeURIComponent(errMsgContainer.dataset.genericError),
  //     fieldError: decodeURIComponent(errMsgContainer.dataset.fieldError),
  //   };

  //   reklamationForm.addEventListener('keypress', function (event) {
  //     var code = event.keyCode || event.which;
  //     if (code === 13) {
  //       event.preventDefault();
  //       return false;
  //     }
  //   });

  //   reklamationForm.addEventListener( 'submit', function (event) {
  //       event.preventDefault();

  //       // noop if form has already been sent and is successful
  //       if (isReklamationFormProcessing) return false;

  //       isReklamationFormProcessing = true;
  //       btnSend.disabled = true;
  //       btnSend.textContent = loading;
  //       errmsg.style.display = 'none';

  //       // initialize error flags and messages
  //       let hasErrors = false;
  //       errmsg.querySelector('.message').innerHTML = errorMessages.genericError;

  //       // validate email
  //       let emailInput = reklamationForm.querySelector('#email');
  //       if (isValidEmail(emailInput.value))
  //         emailInput.classList.remove('error');
  //       else {
  //         emailInput.classList.add('error');
  //         hasErrors = true;
  //       }

  //       if (hasErrors) {
  //         // show field error
  //         showError(tymsg, errmsg, errorMessages.genericError, event, btnSend, btnSendValue);

  //         isReklamationFormProcessing = false;
  //         return false;
  //       }

  //       // form submission
  //       var action = 'form_spareparts';
  //       var url = reklamationForm.dataset.url;
  //       let data = new FormData(reklamationForm);
  //       data.append('action', action);

  //       fetch(url, { method: 'POST', body: data })
  //         .then(function (response) {
  //           if (!response.ok) {
  //             throw Error(response.statusText);
  //           }

  //           return response.json();
  //         })
  //         .then(function () {
  //           isReklamationFormProcessing = false;
  //           tymsg.style.display = 'block';
  //           errmsg.style.display = 'none';
  //           event.target.scrollIntoView({ behavior: 'smooth' });

  //           // Send Email
  //           // sendEmail(data, "/send-email-bestall.php");
  //         })
  //         .catch(function (e) {
  //           console.error(e);
  //           isReklamationFormProcessing = false;

  //           // show generic error
  //           showError(tymsg, errmsg, errorMessages.genericError, event, btnSend, btnSendValue);
  //         });
  //   });
  // }

  // const complaintGoodsAutoCompute = function(event, input) {
  //   if (event.isComposing || event.key === 229) {
  //       return;
  //   }

  //   const parentRow = input.closest('.form-group-row');

  //   const quantityValue = parentRow.querySelector('.quantity input').value.trim();
  //   const unitPriceValue = parentRow.querySelector('.unit-price input').value.trim();
  //   const formWrapper = parentRow.closest('.complaint-goods');

  //   calculateAmountSum(formWrapper, parentRow, quantityValue, unitPriceValue);
  // }

  // const installationWorksAutoCompute = function(event, input) {
  //   if (event.isComposing || event.key === 229) {
  //       return;
  //   }

  //   const parentRow = input.closest('.form-group-row');

  //   const timeValue = parentRow.querySelector('.time input').value.trim();
  //   const unitPriceValue = parentRow.querySelector('.unit-price input').value.trim();
  //   const formWrapper = parentRow.closest('.installation-works');

  //   calculateAmountSum(formWrapper, parentRow, timeValue, unitPriceValue);
  // }

  // function calculateAmountSum(formWrapper, parentRow, input1, input2) {
  //   const amountField = parentRow.querySelector('.amount');

  //   if ( input1.length > 0 && input2.length > 0 ) {
  //     amountField.innerHTML = input1 * input2;
  //   } else {
  //     amountField.innerHTML = 0;
  //   }

  //   let total = 0;
  //   Array.prototype.slice.call(formWrapper.querySelectorAll('.amount')).forEach(function (amount) {
  //     total += parseInt(amount.innerHTML);
  //   });

  //   formWrapper.querySelector('.total-amount').innerHTML = total;
  // }

  // const complaintGoodsQuantityInput = document.querySelectorAll('.complaint-goods .form-group-row .quantity input');
  // Array.prototype.slice.call(complaintGoodsQuantityInput).forEach(function (input) {
  //   input.addEventListener('keyup', function(event){
  //     complaintGoodsAutoCompute(event, input);
  //   });
  // });

  // const complaintGoodsUnitPriceInput = document.querySelectorAll('.complaint-goods .form-group-row .unit-price input');
  // Array.prototype.slice.call(complaintGoodsUnitPriceInput).forEach(function (input) {
  //   input.addEventListener('keyup', function(event){
  //     complaintGoodsAutoCompute(event, input);
  //   });
  // });

  // const installationWorksTimeInput = document.querySelectorAll('.installation-works .form-group-row .time input');
  // Array.prototype.slice.call(installationWorksTimeInput).forEach(function (input) {
  //   input.addEventListener('keyup', function(event){
  //     installationWorksAutoCompute(event, input);
  //   });
  // });

  // const installationWorksUnitPriceInput = document.querySelectorAll('.installation-works .form-group-row .unit-price input');
  // Array.prototype.slice.call(installationWorksUnitPriceInput).forEach(function (input) {
  //   input.addEventListener('keyup', function(event){
  //     installationWorksAutoCompute(event, input);
  //   });
  // });
  // ----- END - SERVICE REKLAMATION -------- //


  function showError(tymsg, errmsg, errorMessage, event, btnSend, btnSendValue) {
    if (tymsg != null) {
      tymsg.style.display = 'none';
    }
    errmsg.style.display = 'block';
    errmsg.querySelector('.message').innerHTML = errorMessage;
    event.target.scrollIntoView({ behavior: 'smooth' });
    
    
    btnSend.disabled = false;
    btnSend.textContent = btnSendValue;
  }

    // document.addEventListener( 'wpcf7submit', function( ) {
    //   this.querySelector('.full-btn').disabled = true;
    // }, false );


});



// WEBPACK FOOTER //
// resources/assets/scripts/forms.js